/* eslint-disable @typescript-eslint/no-explicit-any */
import { EventHandler } from 'react';

export const validateImage = (url: string): Promise<void> => {
  let onError: EventHandler<any> | null = null;
  let onSuccess: EventHandler<any> | null = null;
  const tester = new Image();

  return new Promise((resolve, reject) => {
    onError = reject;
    onSuccess = resolve;

    tester.addEventListener('error', onError);
    tester.addEventListener('load', onSuccess);
    tester.src = url;
  })
    .then(() => {
      tester.removeEventListener('load', onSuccess as EventHandler<any>);
    })
    .catch(e => {
      tester.removeEventListener('error', onError as EventHandler<any>);

      throw e;
    });
};
